import styled from 'styled-components';
import checkRedIcon from '../../assets/icons/svg/check_red.svg';
import minusRedIcon from '../../assets/icons/svg/minus_red.svg';

const bp = { sm: '480px', md: '768px', lg: '1024px', xl: '1280px' };

const Section2Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background: #fff;
  padding: clamp(40px, 6vw, 100px) clamp(16px, 8vw, 80px);
  gap: clamp(32px, 6vw, 60px);
`;

const Title = styled.h2`
  font-size: clamp(20px, 5vw, 48px);
  font-weight: 700;
  color: #212121;
  line-height: 1.3;
  text-align: center;
`;

const ContentContainer = styled.div`
  display: flex;
  gap: clamp(20px, 4vw, 40px);
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
`;

const ContentItem = styled.div`
  flex: 1 1 300px;
  max-width: 540px;
  display: flex;
  flex-direction: column;
  gap: clamp(20px, 4vw, 40px);
  border: 1px solid #ff2828;
  border-radius: 24px;
  padding: clamp(20px, 4vw, 36px);
  background: #fff;

  hr {
    width: 100%;
    border: none;
    border-top: 1px solid #d9d9d9;
  }
`;

const ContentItemTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: clamp(8px, 2vw, 12px);

  h3 {
    font-size: clamp(18px, 4vw, 36px);
    font-weight: 700;
    color: #212121;
    line-height: 1.25;
  }
  h4 {
    font-size: clamp(14px, 3vw, 24px);
    font-weight: 700;
    color: #212121;
    line-height: 1.3;
  }
`;

const ContentItemDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: clamp(16px, 3vw, 28px);
`;

const ContentItemDescriptionWrapper = styled.div`
  display: flex;
  gap: clamp(8px, 2vw, 12px);
  align-items: flex-start;

  p {
    font-size: clamp(14px, 3vw, 22px);
    font-weight: 400;
    color: #212121;
    line-height: 1.4;
  }
`;

const ColDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: clamp(8px, 2vw, 12px);

  div {
    display: flex;
    gap: clamp(8px, 2vw, 12px);
    align-items: center;
  }
`;

const IconContainer = styled.div`
  width: clamp(16px, 3vw, 24px);
  height: clamp(16px, 3vw, 24px);
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
  }
`;

function Section2() {
  return (
      <Section2Container>
        <Title>디지털알리미 울동네는…</Title>
        <ContentContainer>
          <ContentItem>
            <ContentItemTitleWrapper>
              <h3>광고를 원하는 고객</h3>
              <h4>최저 비용으로 최대 광고효과</h4>
            </ContentItemTitleWrapper>
            <hr />
            <ContentItemDescriptionContainer>
              <ContentItemDescriptionWrapper>
                <IconContainer>
                  <img src={checkRedIcon} alt="check_red" />
                </IconContainer>
                <p>원하는 지점을 골라 광고</p>
              </ContentItemDescriptionWrapper>
              <ContentItemDescriptionWrapper>
                <IconContainer>
                  <img src={checkRedIcon} alt="check_red" />
                </IconContainer>
                <p>1,000원 / 1일 ~ 2,000원 / 1일</p>
              </ContentItemDescriptionWrapper>
              <ContentItemDescriptionWrapper>
                <IconContainer>
                  <img src={checkRedIcon} alt="check_red" />
                </IconContainer>
                <ColDescriptionWrapper>
                  <p>
                    광고 1개당 노출횟수 및 시간
                    <br />
                    (40개 광고 유치시)
                  </p>
                  <div>
                    <IconContainer>
                      <img src={minusRedIcon} alt="minus_red" />
                    </IconContainer>
                    <p>500회 / 1일 이상</p>
                  </div>
                  <div>
                    <IconContainer>
                      <img src={minusRedIcon} alt="minus_red" />
                    </IconContainer>
                    <p>60분 / 1일 이상</p>
                  </div>
                </ColDescriptionWrapper>
              </ContentItemDescriptionWrapper>
            </ContentItemDescriptionContainer>
          </ContentItem>

          <ContentItem>
            <ContentItemTitleWrapper>
              <h3>부동산중개사무소</h3>
              <h4>편리한 매물광고와 추가수익</h4>
            </ContentItemTitleWrapper>
            <hr />
            <ContentItemDescriptionContainer>
              <ContentItemDescriptionWrapper>
                <IconContainer>
                  <img src={checkRedIcon} alt="check_red" />
                </IconContainer>
                <p>온라인 매물등록</p>
              </ContentItemDescriptionWrapper>
              <ContentItemDescriptionWrapper>
                <IconContainer>
                  <img src={checkRedIcon} alt="check_red" />
                </IconContainer>
                <p>무제한 매물광고</p>
              </ContentItemDescriptionWrapper>
              <ContentItemDescriptionWrapper>
                <IconContainer>
                  <img src={checkRedIcon} alt="check_red" />
                </IconContainer>
                <p>
                  추가수익 기대
                  <br />
                  (광고유치수 등에 따라 차이)
                </p>
              </ContentItemDescriptionWrapper>
            </ContentItemDescriptionContainer>
          </ContentItem>
        </ContentContainer>
      </Section2Container>
  );
}

export default Section2;
